<template>
  <div class="i-footer-section">
    <img
      class="logo"
      :src="logoWhite"
      loading="lazy"
      alt="Jobtest Logo"
    />
    <div class="text">Unlock the future you deserve.</div>
    <div class="actions">
      <div class="links">
        <a
          class="link"
          href="https://www.jobtest.org/terms-of-service"
          target="_blank"
          >Terms</a
        >
        <a
          class="link"
          href="https://www.jobtest.org/privacy-policy"
          target="_blank"
          >Privacy Policy</a
        >
      </div>
      <div class="copyright">Copyright © {{ new Date().getFullYear() }} | Realign, Inc.</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// ASSETS
import logoWhite from "@/assets/logo/logo-white.svg"
</script>

<style scoped lang="scss">
.i-footer-section {
  @include flex(column, center, center, $gap: 32px);
  @include text-md;

  text-align: center;
  font-weight: 500;
  background-image: linear-gradient(0deg, #0009 0%, #0009 100%), linear-gradient(90deg, #068eff 0%, #ab2af3 100%);
  padding: 25px;
  color: $black200;

  @media screen and (min-width: $breakpoint-md) {
    padding: 60px;
  }

  .logo {
    width: 147px;
  }

  .text {
    @include display-sm;

    color: $white;
    font-weight: 700;

    @media screen and (min-width: $breakpoint-sm) {
      @include display-md;
    }

    @media screen and (min-width: $breakpoint-md) {
      @include display-lg;
    }
  }

  .actions {
    @include flex(column, center, center, $gap: 25px);

    .links {
      @include flex(row, center, center, $gap: 32px);

      .link {
        @include text-xl;

        color: $black200;

        &:hover {
          color: $white;
        }
      }
    }
  }
}
</style>
